module.exports = __webpack_public_path__ + "static/pcb2-141c7fae0c033f19d0962eb53f654328.png";